import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {Helmet} from 'react-helmet';
import { useDispatch, useSelector } from "react-redux";
import AboutUs from "../aboutus";
import Faqs from "../faqs";
import Portfolios from "../portfolios";
import Features from "../features";
import Pricing from "../pricing";
import Services from "../services";
import Teams from "../teams";
import Testimonials from "../testimonials";
import Clients from "../clients";
import Certificate from "../Certificate";
import Contact from "../contact";

const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "How can I contact Pankaj Singh for website development?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can contact me by filling out the form on this page, calling me directly at +91-7838704822, or emailing me at info@pankj.com or csepksingh@gmail.com."
      }
    },
    {
      "@type": "Question",
      "name": "What is your working schedule?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I am available from Monday to Friday, 9:00 AM to 9:00 PM IST. For urgent projects or queries, you can also message me on WhatsApp."
      }
    },
    {
      "@type": "Question",
      "name": "Do you take international website development projects?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I work remotely with clients from all over the world including the US, UK, Canada, UAE, and Australia. Communication is done via email, WhatsApp, or Zoom."
      }
    },
    {
      "@type": "Question",
      "name": "Where are you located?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I am based in DLF Phase 3, Cyber City, Gurgaon, Haryana, India. I offer both local and remote freelance web development services."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer free consultations?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I offer a free 15-minute consultation to understand your project requirements and guide you with the best solution."
      }
    },
    {
      "@type": "Question",
      "name": "Can I message you on WhatsApp?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. You can reach me via WhatsApp at any time using this link: https://whatsapp.com/channel/0029VaoeHx3KmCPOqD4cLt3Q"
      }
    }
  ]
}

function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
  <title>Contact Me - Website Designer Gurgaon</title>
  <meta name="description" content="website designer gurgaon, Delhi, Noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India."/>
  <meta name="keywords" content="pankaj, pankj, web designers near me, website designer near me, web designing company in gurgaon, website designer gurgaon, website development company in gurgaon,freelance web designer, web design gurgaon, website design gurgaon, web design companies near me, web design company, website design company"/>
<meta property="og:title" content="Contact Me - website designer gurgaon | website development company in gurgaon" />
<meta property="og:description" content="website designer gurgaon, Delhi, Noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India." />
<meta property="og:site_name" content="Contact Me - website designer gurgaon | website development company in gurgaon" />
<meta property="og:url" content="https://www.pankj.com/contact"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Contact Me - website designer gurgaon | website development company in gurgaon" />
<meta name="twitter:description" content="website designer gurgaon, delhi, noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India." />
<link rel="canonical" href="https://www.pankj.com/contact" />
        </Helmet>
   <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/pankaj-web-designer5.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
                    <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />

 <h1 className="multiple_effects" id="text3d">Contact</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.png" alt="Website Development Company Gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>  

    <main id="main">
    <Contact /> 
    </main>
    </>
  );
}
export default App1;
